import { get } from 'lodash';
import APIClient from '../../../../common/services/APIClient';
import { CHARGER_ONLINE_NO, CHARGER_ONLINE_YES } from '../../../../common/constants/statuses';

export const fetchEdgeControllersData = async ({ isDomesticSupervisor = false } = {}) => {
  try {
    const [coreDevicesResp, customersResp, plazasResp] = await Promise.all([
      APIClient.get('/plazas/core-devices'),
      isDomesticSupervisor
        ? APIClient.get('/customers').catch(() => ({ data: { payloads: [] } }))
        : Promise.resolve({ data: { payloads: [] } }),
      APIClient.get('/plazas', {
        params: { page_token: 0, page_size: 999 },
      }).catch(() => ({ data: { payloads: [] } })),
    ]);

    const coreDevices = Array.isArray(coreDevicesResp.data) ? coreDevicesResp.data : [];
    const customers = get(customersResp, 'data.payloads', []);
    const plazas = get(plazasResp, 'data.payloads', []);

    const customerMap = Object.fromEntries(
      customers.map(({ customerId, customerName, url }) => [customerId, { name: customerName || customerId, url: url || '' }]),
    );
    const plazaNamesMap = Object.fromEntries(plazas?.map(({ uuid, name }) => [uuid, name]));

    return coreDevices.map((device) => ({
      ...device,
      plaza_name: plazaNamesMap[device.plaza_id] || '',
      uuid: device.device_id,
      online: device.online ? CHARGER_ONLINE_YES : CHARGER_ONLINE_NO,
      customerName: customerMap[device.customer_id]?.name || device.customer_id || '',
      customerUrl: customerMap[device.customer_id]?.url || '',
      firmwareVersion: device.last_release_name || '',
    }));
  } catch (error) {
    console.log('Api error ', error);
    throw new Error(`Api error: ${error}`);
  }
};
